import type { ValidProperties } from '@wmgone/analytics';

import type { UserWithActions } from '~/modules/auth';
import type { Brand } from '~/modules/branding/types';

/**
 * Returns an object that is the set of valid properties used for the user and
 * event properties for Analytics tracking.
 * @param user The user object.
 * @param brand The Brand object.
 */
export function getAnalyticsProperties(user: UserWithActions, brand: Brand) {
  const { email, name, isInternal, profile } = user;

  const properties: ValidProperties = {
    name,
    email,
    is_external: !isInternal,
    product: brand.product,
  };

  if (profile) {
    properties.business_unit = profile.businessUnit;
    properties.job_family_group = profile.jobFamilyGroup;
    properties.team = profile.team;
    properties.label = profile.label;
    properties.job_title = profile.title;
    properties.country_code = profile.countryCode;
    properties.organization = profile.organization;
    properties.company = profile.company;
    properties.user_type = profile.userType;

    if (profile.description) {
      properties.user_description = profile.description;
    }

    if (profile.department) {
      properties.department = profile.department;
    }
  }

  return properties;
}
